import {Button, DialogActions, DialogContent, DialogTitle, TextField, Typography} from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import {
	clearManageWorkspaceView,
	confirmWorkspaceTransfer,
	selectTargetUser
} from "../../reducers/manageWorkspaceSlice"
import { selectWorkspace } from "../../reducers/workspaceSlice"
import { useState } from "react"
import {ManageModalContainer} from "./shared_components/ManageModalContainer"

export default function TransferOwnership() {

	const dispatch = useDispatch()
	const targetUser = useSelector(selectTargetUser)
	const workspace = useSelector(selectWorkspace)
	const firstName = targetUser?.user?.firstName
	const lastName = targetUser?.user?.lastName
	const email = targetUser?.user?.email
	const [workspaceTitleInput, setWorkspaceConfirmationText] = useState("")
	const [confirmationError, setConfirmationError] = useState(false)
	
	const handleConfirmationOnChange = (e) => {
		setConfirmationError(workspaceTitleInput !== workspaceTitleInput)
		setWorkspaceConfirmationText(e.target.value)
	}

	const handleClickConfirm = () => {
		if(targetUser) {
			dispatch(confirmWorkspaceTransfer({
				userId: targetUser?.user?.id,
				workspaceId: workspace.id
			}))
		}
	}

	return (
		<ManageModalContainer>
			<DialogTitle>
				Transfer Workspace Ownership
			</DialogTitle>
			<DialogContent>
				<Typography variant={"tunedH3"} paragraph>
					You are attempting to transfer ownership of this workspace to <Typography component="span" fontWeight="bold">{`${firstName} ${lastName} (${email})`}</Typography>.
					<br />
					Type the name of this workspace (<Typography component="span" fontWeight="bold">{`${workspace.title}`}</Typography>) and press confirm to complete the transfer of ownership and upgrade selected user to an admin role.
				</Typography>
				<TextField
					autoFocus
					variant="outlined"
					value={workspaceTitleInput}
					onChange={(e) => handleConfirmationOnChange(e)}
					error={confirmationError}
					fullWidth
				/>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={handleClickConfirm}
					variant={"contained"}
					color={"primary"}
					disabled={workspace.title !== workspaceTitleInput}
				>
					Confirm
				</Button>
				<Button
					color={"error"}
					onClick={() => {
						dispatch(clearManageWorkspaceView())
					}
					}
				>
					Cancel
				</Button>
			</DialogActions>
		</ManageModalContainer>
	)
}